module.exports = __webpack_public_path__ + "img/Margault Blanchard.c38af1e9.jpg";